import './AuthCardLayout.scss';

import Box           from '@widesk-ui/components/Box';
import View          from '@widesk-ui/components/View';
import Button        from '@widesk-ui/components/Button';
import useThemeMode  from '@widesk-ui/hooks/useThemeMode';
import SunIcon       from '@widesk-ui/components/SunIcon';
import MoonIcon      from '@widesk-ui/components/MoonIcon';
import React         from 'react';
import useIsMobile   from '@/hooks/useIsMobile';

type AuthCardLayoutProps = {
	children: React.ReactNode;
	width?: number;
}

// Layout des pages publiques d'authentification de l'app (connexion, mot de passe oublié, nouveau
// mot de passe) : canevas pointillé en fond + carte vitrée centrée + bascule de thème. Copie
// volontairement distincte de celle de widesk-ui pour ne pas y coupler le style de ces pages.
export default function AuthCardLayout({ children, width = 420 }: AuthCardLayoutProps) {
	const { mode, setMode } = useThemeMode();
	const isDark = mode === 'dark';
	const isMobile = useIsMobile();

	return (
		<View heightF center rel className="auth-card-layout">
			<View absF absT={0} absL={0} absR={0} absB={0} className="auth-card-layout__canvas" />

			<Box
				className="auth-card-layout__card"
				style={{
					width,
					maxWidth: 'calc(100vw - 32px)',
					borderRadius: 18,
					background: 'color-mix(in srgb, var(--ant-color-bg-container) 72%, transparent)',
					border: '1px solid color-mix(in srgb, var(--ant-color-border) 70%, transparent)',
					backdropFilter: 'blur(16px)',
					WebkitBackdropFilter: 'blur(16px)',
				}}
				bodyStyle={{ padding: isMobile ? 20 : 28 }}
			>
				{children}
			</Box>

			<Button
				className="auth-card-layout__theme-toggle"
				icon={isDark ? <SunIcon /> : <MoonIcon />}
				onClick={() => setMode(isDark ? 'light' : 'dark')}
				title={isDark ? 'Afficher le thème clair' : 'Afficher le thème sombre'}
				style={{
					position: 'absolute',
					top: 16,
					right: 16,
					width: 40,
					height: 40,
					padding: 0,
					borderRadius: '50%',
					display: 'flex',
					alignItems: 'center',
					justifyContent: 'center',
					fontSize: 18,
					color: 'var(--ant-color-text)',
					background: 'color-mix(in srgb, var(--ant-color-bg-container) 88%, transparent)',
					border: '1px solid color-mix(in srgb, var(--ant-color-border) 90%, transparent)',
					boxShadow: '0 4px 12px -4px rgba(0,0,0,.25)',
					backdropFilter: 'blur(8px)',
					WebkitBackdropFilter: 'blur(8px)',
				}}
			/>
		</View>
	);
}
